__turbopack_context__.v({
  "className": "oswald_c4b3f449-module__kvEvIa__className",
});
